/**
 * A comment thread is uniquely identified by the resource it hangs off:
 * `onModel` (e.g. 'claim', 'bill') + the resource's Mongo id. The reducer
 * keeps one bucket per key so a panel with several resource tabs
 * (Claim / Bill 1 / Bill 2) can hold every thread at once without refetch
 * flicker when switching tabs.
 */
export const commentThreadKey = (onModel, resourceId) => `${onModel}:${resourceId}`;
